
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import { installEncodedLocalStorage } from "./utils/localStorageCodec";
  import "./index.css";

  installEncodedLocalStorage();

  createRoot(document.getElementById("root")!).render(<App />);
  
